module.exports = __webpack_public_path__ + "static/16-1fce36c4115008223ad96bc4441e2ccd.jpg";